/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { useCallback } from 'react';

import { jsx, cssMap } from '@compiled/react';
import { useIntl } from 'react-intl';

import Button from '@atlaskit/button/new';
import { aiSuggestionsMessages } from '@atlaskit/editor-common/ai-messages';
import ArrowDownIcon from '@atlaskit/icon/core/arrow-down';
import ArrowUpIcon from '@atlaskit/icon/core/arrow-up';
import { Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

type ScrollBackToSuggestionButtonProps = {
	direction: 'up' | 'down';
	onClick: () => void;
};

const styles = cssMap({
	buttonContainer: {
		paddingTop: token('space.050'),
		paddingRight: token('space.050'),
		paddingBottom: token('space.050'),
		paddingLeft: token('space.050'),
		backgroundColor: token('elevation.surface.raised'),
		boxShadow: token('elevation.shadow.overlay'),
		borderRadius: token('radius.xlarge'),
		border: 'none',
	},
});

export const ScrollBackToSuggestionButton = ({
	direction,
	onClick,
}: ScrollBackToSuggestionButtonProps): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const label = formatMessage(aiSuggestionsMessages.cardScrollBackToSuggestionLabel);

	const ArrowIcon = useCallback(() => {
		return direction === 'up' ? (
			<ArrowUpIcon label="" size="small" />
		) : (
			<ArrowDownIcon label="" size="small" />
		);
	}, [direction]);

	return (
		<div css={styles.buttonContainer}>
			<Button appearance="subtle" iconBefore={ArrowIcon} onClick={onClick}>
				<Text size="medium" color="color.text.subtle">
					{label}
				</Text>
			</Button>
		</div>
	);
};
